import { Box } from '@mui/material';
import { Done } from '@mui/icons-material';
import { brand, green, orange, red } from '../../../theme/themePrimitives';

interface ColorPickerProps {
    selected: string;
    onChange: (value: string) => void
}

const ColorPickerComponent = ({ selected, onChange }: ColorPickerProps) => {
    const colors = [
        {
            label: 'danger',
            value: 'danger',
            color: red[300]
        },
        {
            Label: 'warning',
            value: 'warning',
            color: orange[300]
        },
        {
            label: 'success',
            value: 'success',
            color: green[300]
        },
        {
            label: 'primary',
            value: 'primary',
            color: brand[300]
        }
    ];
    return <Box display="flex" alignItems="center" gap="10px" width="100%">
        {
            colors.map((color, index) => (
                <Box key={index} bgcolor={color.color} height="40px" width="40px" borderRadius="50%" display="flex" alignItems="center" justifyContent="center" color="white" onClick={() => onChange(color.value)}>
                    {selected === color.value && <Done fontSize="small" />}
                </Box>
            ))
        }
    </Box>;
};

export default ColorPickerComponent;